import * as React from "react";
import { IReferralListSummary } from "../../../../models/IReferral";
import { ReferralApi } from "../../../../api/ReferralApi";
import { useAuth } from "../../../../App";
import { SpinnerWrapper, PaginationNavigation } from "soprasteria-ui-library";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import { IPage } from "../../../../models/IPage";
import { ReferralUnderReviewSummaryTable } from "./ReferralUnderReviewSummaryTable";
import { useParams, useHistory } from "react-router-dom";
import { REFERRAL_SUMMARY } from "../../../../utils/RouteConstants";

export const ReferralUnderReviewSummary: React.FunctionComponent<{}> = () => {

    const api = new ReferralApi(useAuth());
    const history = useHistory();
    const pageSize = 20;

    const { page } = useParams<{page: string}>();
    const [referrals, setReferrals] = React.useState<IReferralListSummary[]>();
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const [isFetchingReferrals, setIsFetchingReferrals] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (page) {
            getReferralsUnderReview(parseInt(page, 10));
        }
    }, [page]);

    const getReferralsUnderReview = (pageNumber: number) => {
        setIsFetchingReferrals(true);
        const pageSelect: IPage = { pageNumber: pageNumber, pageSize: pageSize }
        api.getReferralsUnderReviewSummary(pageSelect, (response) => {
            setReferrals(response.data);
            setPaginationHeader(response.paginationHeader);
        }, undefined, () => {
            setIsFetchingReferrals(false);
        });
    }

    const handleClickedPage = (page: number) => {
        history.push(`/${REFERRAL_SUMMARY}/${page}`)
    }

    return (
        <SpinnerWrapper isLoading={isFetchingReferrals}>
            <section className="card">
                <div className="card-header">
                    <h1>Specialistremisser under granskning</h1>
                </div>
                <div className="card-body">
                    {
                        referrals ?
                            <>
                                <ReferralUnderReviewSummaryTable referrals={referrals} />
                                <PaginationNavigation
                                    ariaLabel="referrals under review summary pagination selector"
                                    pagination={paginationHeader}
                                    pageNeighbours={2}
                                    selectedPage={page => handleClickedPage(page)}
                                    showCount={true} />
                            </>
                            : null
                    }
                </div>
            </section>
        </SpinnerWrapper>
    )
}
